<template>
<div class="chapter">
<div class="inner_page">
<p class="otherfm"><a id="page_viii"></a><em>The tree of liberty must be refreshed</em></p>
<p class="otherfm"><em>from time to time with … blood.</em></p>
<p class="righta">—Thomas Jefferson</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// otherfm02.vue?b7ef31b2